import React from "react";
import ChartGoal from "charts/ChartGoal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MetricFormatter from "dashboards/MetricFormatter";
import ReactDOMServer from "react-dom/server";

class KeywordBlock extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    const yyText = ReactDOMServer.renderToString(<MetricFormatter.YY value={this.props.yy ? this.props.yy : 0} />);
    const goodOrBadText = this.props.negative ? (this.props.yy >= 0 ? "text-danger" : "text-success") : this.props.yy >= 0 ? "text-success" : "text-danger";
    const goodOrBadBg = this.props.negative ? (this.props.yy >= 0 ? "bg-danger" : "bg-success") : this.props.yy >= 0 ? "bg-success" : "bg-danger";
    return (
      <div className="keyword-block my-3 mx-auto">
        <h5>{this.props.metricName}</h5>
        <div style={{ opacity: this.props.yy ? 1 : 0, margin: "inherit" }} className={`metric-block-number text-center ${goodOrBadText}`}>{`${
          this.props.metric ? this.props.metric : 0
        } (${yyText})`}</div>
        {/* <div className={`keyword-block-new`}>{`New: ${this.props.new}`}</div>
        <div className={`keyword-block-new`} >{`Lost: ${this.props.lost}`}</div> */}
      </div>
    );
  }
}

export default KeywordBlock;
